import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";
import store from '../../../store';
import {
    required,
    integer,
    minValue,
    maxValue
} from "vuelidate/lib/validators";
import ValidationService from "@/services/ValidationService";

export default {
    name: 'scoreSettingCreate',
    components: {
        MainLayout,
        Loading,
        Select2Multiple,
    },
    mixins: [ValidationService],
    data() {
        return {
            acdYearList: [],
            gradeList: [],
            isLoading: true,
            disabled: false,
            submitted: false,
            scoreData: {
                acdYearId: '',
                campusGradeId: '',
                termExamRate: '',
                unitTestRate: '',
                projectRate: '',
            }
        };
    },

    validations: {
        scoreData: {
            acdYearId: {
                required,
                integer
            },
            campusGradeId: {
                required,
                integer,
            },
            termExamRate: {
                integer,
                maxLength: maxValue(100),
                minValue: minValue(0)
            },
            unitTestRate: {
                integer,
                maxLength: maxValue(100),
                minValue: minValue(0)
            },
            projectRate: {
                integer,
                maxLength: maxValue(100),
                minValue: minValue(0)
            },
        },
    },

    watch: {
        'scoreData.acdYearId'(newVal) {
            this.scoreData.campusGradeId = '';
            this.gradeList = [];
            this.validationErrors = {};
            this.submitted = false;
            if (!newVal) return;
            this.isLoading = true;
            this.getGradeList(newVal);
        },
        'scoreData.campusGradeId'() {
            if (this.validationErrors.campus_grade_id) {
                this.$delete(this.validationErrors, 'campus_grade_id');
            }
        },
    },

    methods: {
        blockInvalidNumberInput(field) {
            let value = this.scoreData[field].replace(/[^0-9]/g, '');
            this.scoreData[field] = value;
        },

        async getParentAcdYearList() {
            try {
                const response = await axios.get('score-setting/parent-acd-year');
                if (response.data) {
                    const rawData = response.data.data;
                    this.acdYearList = rawData.map(item => ({
                        id: item.id,
                        text: item.period_name
                    }));

                    //for active period auto select
                    const activeId = response.data.active_acd_year_id;
                    this.scoreData.acdYearId =
                        activeId ?? this.acdYearList?.[0]?.id ?? null;
                }
            } catch (error) {
                if (error.response?.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Error fetching academic year list:", error);
            } finally {
                this.isLoading = false;
            }
        },

        getGradeList(yearId) {
            if (!yearId) {
                this.gradeList = [];
                this.isLoading = false;
                return;
            }
            axios.get('campusGrade/list-by-acdYear', {
                params: {
                    campus_id: store.state.user.campus_id,
                    acd_year_id: yearId,
                    get_grade: true,
                },
            }).then((res) => {
                const rows = Array.isArray(res.data) ? res.data : [];
                this.gradeList = rows.map((g) => ({
                    id: g.campus_grade_id,
                    text: g.grade_name,
                }));
                this.isLoading = false;
            }).catch((error) => {
                if (error.response?.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Error fetching grade list:", error);
                this.isLoading = false;
            });
        },

        showList() {
            this.$router.push({
                path: "/score-setting"
            })
        },

        create() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.clearValidationErrors();
            this.disabled = true;
            this.isLoading = true;
            const request = {
                acd_year_id: this.scoreData.acdYearId,
                campus_grade_id: this.scoreData.campusGradeId,
                term_exam_rate: this.scoreData.termExamRate,
                unit_end_test_rate: this.scoreData.unitTestRate,
                project_rate: this.scoreData.projectRate,
            };
            axios.post('/score-setting', request)
                .then((res) => {
                    this.disabled = false;
                    if (res.data.success === true) {
                        this.isLoading = false;
                        this.$notification.success(res.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.showList();
                    }
                })
                .catch(error => {
                    this.disabled = false;
                    if (error.response?.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else if (error.response?.status == 422) {
                        this.printValidationError(error.response);
                    }
                    this.isLoading = false;
                })
        }
    },

    mounted() {
        this.isLoading = true;
        this.getParentAcdYearList();
    },
};
